var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlexibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 41,
    viewBox: "0 0 33 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.2856 24.7856L22.7142 12.357",
    stroke: "url(#paint0_linear_492_327)",
    strokeWidth: 2.41853,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.3214 14.4284C11.8934 14.4284 12.3571 13.9647 12.3571 13.3927C12.3571 12.8207 11.8934 12.357 11.3214 12.357C10.7493 12.357 10.2856 12.8207 10.2856 13.3927C10.2856 13.9647 10.7493 14.4284 11.3214 14.4284Z",
    fill: "black",
    stroke: "url(#paint1_linear_492_327)",
    strokeWidth: 2.41853,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.6788 24.7857C22.2508 24.7857 22.7145 24.322 22.7145 23.75C22.7145 23.178 22.2508 22.7143 21.6788 22.7143C21.1068 22.7143 20.6431 23.178 20.6431 23.75C20.6431 24.322 21.1068 24.7857 21.6788 24.7857Z",
    fill: "black",
    stroke: "url(#paint2_linear_492_327)",
    strokeWidth: 2.41853,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2 39.2857V6.14286C2 5.0441 2.43648 3.99035 3.21341 3.21341C3.99035 2.43648 5.0441 2 6.14286 2H26.8571C27.9559 2 29.0096 2.43648 29.7866 3.21341C30.5635 3.99035 31 5.0441 31 6.14286V39.2857L24.7857 35.1429L20.6429 39.2857L16.5 35.1429L12.3571 39.2857L8.21429 35.1429L2 39.2857Z",
    stroke: "url(#paint3_linear_492_327)",
    strokeWidth: 2.41853,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_492_327",
    x1: 16.4999,
    y1: 12.357,
    x2: 16.4999,
    y2: 24.7856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CAB31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2CAB93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_492_327",
    x1: 11.3214,
    y1: 12.357,
    x2: 11.3214,
    y2: 14.4284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CAB31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2CAB93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_492_327",
    x1: 21.6788,
    y1: 22.7143,
    x2: 21.6788,
    y2: 24.7857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CAB31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2CAB93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_492_327",
    x1: 16.5,
    y1: 2,
    x2: 16.5,
    y2: 39.2857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CAB31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2CAB93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexibility);
export default __webpack_public_path__ + "static/media/flexibility.80dc59271bcd4a989862cd28737763b1.svg";
export { ForwardRef as ReactComponent };